import axios from 'axios'
import { getToken } from './tokens'
import store from './store'

export function follow(contentId, contentType, contentTitle) {
  return getToken().then( (token, refreshToken) => {
    const userId = store.getState().user.userId
    return axios({
      method: 'POST',
      url: `${ window.settings.apiBaseUrl }/user/follows`,
      params: { site: window.settings.internalName, userId: userId },
      data: {
        contentType: contentType,
        contentId: contentId,
        title: contentTitle
      },
      headers: { 
        Authorization: token,   
        'x-api-key': window.settings.baseAPIKey 
      }
    }).then( res => {
      return res.data;
    })
  });
}

export function unfollow(contentId) {
  return getToken().then( (token, refreshToken) => {
    const userId = store.getState().user.userId
    return axios({
      method: 'DELETE',
      url: `${ window.settings.apiBaseUrl }/user/follows/${contentId}`,
      params: { site: window.settings.internalName, userId: userId },
      headers: { 
        Authorization: token,   
        'x-api-key': window.settings.baseAPIKey 
      }
    }).then( res => {
      return res.data;
    })
  });
}

export function getFollows(contentType) {
 return getToken().then( (token, refreshToken) => {
    const userId = store.getState().user.userId
    return axios({
      method: 'GET',
      url: `${ window.settings.apiBaseUrl }/user/follows`,
      params: { site: window.settings.internalName, userId: userId, contentType: contentType },
      headers: { 
        Authorization: token,   
        'x-api-key': window.settings.baseAPIKey 
      }
    }).then( res => {
      return res.data;
    })
  });
}
